// @flow strict

import React from "react";
// $FlowFixMe[missing-export]
import { Overlay } from "react-overlays";
import { InFrame } from "~robin-hood/Frame";
import type { Agent, Equipo } from "~robin-hood/redux/store";
import { GROUP_CREATOR, AGENT_NAME } from "~robin-hood/redux/store";
import { PLAYERS, AVATAR_PLAYER, NAME_PLAYER } from "~robin-hood/utils";
import type { Player } from "~robin-hood/utils";

import { now } from "~common/utils";
import styles from "./WaitForStart.module.css";
import classnames from "~common/classnames";

type Props = {
  agent: Agent,
  equipo: Equipo,
  updateEquipo: (Equipo) => void,
};

export function WaitForStart({
  agent,
  equipo,
  updateEquipo,
}: Props): React$Node {
  const [showOverlay, setShowOverlay] = React.useState<?Player>(null);
  return (
    <InFrame>
      <div className={styles.background}>
        <div className={styles.wrapper}>
          <div className={styles.waitForStart}>
            <header> Bienvenido Agente {AGENT_NAME.get(agent)}.</header>
            <div>
              <p>
                Vuestra misión es hacer un ataque cibernético conjunto para
                conseguir liberar todo el dinero robado, pero tendréis que daros
                prisa porque sólo dispondréis de 60 minutos.
              </p>
              <p>
                A cada uno de vosotros, se os han asignado una o varias cuentas
                de estos ladrones de guante blanco que tendréis que hackear. Una
                vez hayáis entrado en todas las cuentas, deberéis coordinaros
                para hacer frente a un desafiante programa de seguridad
                informática y así poder acceder al dinero. ¡Animo y suerte!
              </p>
            </div>
            <div className={classnames(styles.avatars)}>
              {PLAYERS.map((p) => (
                <AvatarOverlay
                  key={p}
                  player={p}
                  showOverlay={showOverlay}
                  setShowOverlay={setShowOverlay}
                />
              ))}
            </div>
            <div>
              {agent === GROUP_CREATOR ? (
                <p>
                  {`PS: ¡Coged papel y boli, poned el navegador en pantalla completa (pulsad F11) y cuando estéis todos listos pulsa
                  "START"!`}
                </p>
              ) : (
                <p>
                  {`PS: ¡Coged papel y boli, poned el navegador en pantalla completa (pulsad F11) y cuando estéis todos listos avisad al
                  Agente 001 para que pulse "START"!`}
                </p>
              )}
            </div>
            {agent === GROUP_CREATOR && (
              <div className={styles.start}>
                <span
                  className={styles.startButton}
                  onClick={() => {
                    updateEquipo({ ...equipo, startTime: now() });
                  }}
                >
                  START
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </InFrame>
  );
}

type AvatarOverlayProps = {
  player: Player,
  showOverlay: ?Player,
  setShowOverlay: (?Player) => void,
};
function AvatarOverlay(props: AvatarOverlayProps) {
  const { player, showOverlay, setShowOverlay } = props;

  const avatarRef = React.useRef(null);
  const containerRef = React.useRef(null);

  return (
    <div
      ref={containerRef}
      className={styles.avatar}
      onClick={() =>
        showOverlay !== player ? setShowOverlay(player) : setShowOverlay(null)
      }
    >
      <img
        ref={avatarRef}
        alt="Avatar"
        className={classnames(styles.avatarImg)}
        src={AVATAR_PLAYER.get(player)}
      />
      <div className={styles.agentOverlay}>
        <span className={styles.agentOverlaySpan}>
          {NAME_PLAYER.get(player)}
        </span>
      </div>
      {/* <Overlay
        show={showOverlay === player}
        rootClose
        onHide={() => setShowOverlay(null)}
        placement={"bottom"}
        container={containerRef}
        target={avatarRef}
      >
        {() => (
          
        )}
      </Overlay> */}
    </div>
  );
}
